import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {Dac6ReporterConfig} from '../orbitax-dac6-reporter-config';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Api} from "@shared/constants/common-field.constants";
import {Configuration} from "@shared/models/configuration";

/**
 * Created by shamim.ahsan on 10/24/2018.
 */
@Injectable()
export class TransmissionService {
  constructor(private httpClient: HttpClient) {
  }
  magicLinkModel: MagicLinkModel;
  getFilingTypeModels(solutionId: string = '',api: string = "TransmissionApi"): Observable<any> {
    //return this.httpClient.get<any>(`${Dac6ReporterConfig.TransmissionAPI}Transmission/FilingTypes?solutionId=${solutionId}`);
    return this.httpClient.get<any>(`${Configuration.getConfig(api)}Transmission/FilingTypes?solutionId=${solutionId}`);
  }
  getReportingCountry(api: string = "TransmissionApi"): Observable<any> {
   // return this.httpClient.get<any>(`${Dac6ReporterConfig.TransmissionAPI}Transmission/SupportedCountries`);
   return this.httpClient.get<any>(`${Configuration.getConfig(api)}Transmission/SupportedCountries`);
  }
}


